import request from '../../utils/request'
const getPoster = (data) => {
    return request({
        url: `mp/fission/share/poster`,
        method: 'get',
    })
}
const getDistribution= () => {
    return request({
        url: `mp/fission/home`,
        method: 'get',
    })
    
}
const shareUrl= () => {
  return request({
      url: `/mp/fission/share/url`,
      method: 'get',
  })
  
}
export {
    getPoster,
    getDistribution,
    shareUrl
}